import { chartManager } from '../manager';
export class SteppedMarkersLineSeriesRenderer {
    constructor() {
        this._data = null;
        this._options = null;
    }
    draw(target, priceConverter) {
        target.useBitmapCoordinateSpace(scope => this._drawImpl(scope, priceConverter));
    }
    update(data, options) {
        this._data = data;
        this._options = options;
    }
    _drawSteps(x, steps, valueLine, renderingScope, priceToCoordinate) {
        if (!steps || !steps.length) {
            return;
        }
        for (const step of steps) {
            const stepValue = priceToCoordinate(step) * renderingScope.verticalPixelRatio;
            valueLine.lineTo(x, stepValue);
        }
    }
    _drawPrimitive(bar, valueLine, renderingScope, priceToCoordinate, isFirst = false) {
        if (isFirst) {
            valueLine.moveTo(bar.x, bar.value);
        }
        if (bar.steps && bar.steps.length > 0) {
            this._drawSteps(bar.x, bar.steps, valueLine, renderingScope, priceToCoordinate);
        }
        else {
            valueLine.lineTo(bar.x, bar.value);
        }
    }
    _drawSeries(renderingScope, bars, priceToCoordinate, lineWidth) {
        if (this._data === null ||
            this._data.bars.length === 0 ||
            this._data.visibleRange === null ||
            this._options === null) {
            return;
        }
        renderingScope.context.beginPath();
        const line = new Path2D();
        const firstBar = bars[this._data.visibleRange.from];
        this._drawPrimitive(firstBar, line, renderingScope, priceToCoordinate, true);
        for (let i = this._data.visibleRange.from + 1; i < this._data.visibleRange.to; i++) {
            const bar = bars[i];
            this._drawPrimitive(bar, line, renderingScope, priceToCoordinate);
        }
        renderingScope.context.lineJoin = 'bevel';
        renderingScope.context.strokeStyle = this._options.color;
        renderingScope.context.lineWidth =
            lineWidth * renderingScope.verticalPixelRatio;
        renderingScope.context.stroke(line);
        return line;
    }
    _drawImpl(renderingScope, priceToCoordinate) {
        var _a;
        if (this._data === null ||
            this._data.bars.length === 0 ||
            this._data.visibleRange === null ||
            this._options === null) {
            return;
        }
        const lineWidth = Math.min(((_a = this._options) === null || _a === void 0 ? void 0 : _a.lineWidth) || 1, this._data.barSpacing);
        const bars = this._data.bars.map(bar => {
            return {
                x: bar.x * renderingScope.horizontalPixelRatio,
                y: priceToCoordinate(bar.originalData.value) || 0,
                value: priceToCoordinate(bar.originalData.value) *
                    renderingScope.verticalPixelRatio,
                steps: bar.originalData.steps,
                marker: bar.originalData.marker,
            };
        });
        const line = this._drawSeries(renderingScope, bars, priceToCoordinate, lineWidth);
        if (this._options.id) {
            chartManager.addPrimitive(this._options.id, {
                path: line,
                isHit: (p, x, y) => {
                    const relativeX = x * renderingScope.horizontalPixelRatio;
                    const relativeY = y * renderingScope.verticalPixelRatio;
                    /**
                     * Note:
                     *
                     * Given the lineWidth of these line series are set to 2px (per design)
                     * Doing a hit text with in 2px although the math works, makes it
                     * impossible for the user to click exactly within that 2px of the line.
                     *
                     * So here comes the hack. Only when doing the hit test of the line,
                     * we pad/ fake the lineWidth to be 15 so user is allowed to click and
                     * swap the line within certain tolerance.
                     *
                     * Later after the hit test is determined, we reset it to desired lineWidth set via options
                     */
                    renderingScope.context.lineWidth = 15;
                    const result = renderingScope.context.isPointInStroke(p, relativeX, relativeY);
                    renderingScope.context.lineWidth = lineWidth;
                    return result;
                },
            });
        }
        renderingScope.context.closePath();
    }
}
